var Acr = Acr || {};

Acr.HeroCarousel = function () {
  

  Utility.log('HeroCarousel.js loaded');

  // Selectors
  var heroSlider;
  var hero;
  var media;

  // Data
  var changeSlide = function () {};
  var canPlayVideo = true;
  var triggerPos = function () {};
  var breakpoint = null;
  var ratioWidth = 16;
  var ratioHeight = 9;
  var ratioWidthSM = 1100;
  var ratioHeightSM = 756;
  var playSvg;
  var arrowLeft;
  var arrowRight;
  var heroSwiper;
  var heroCarousel;
  var swiperPagination;
  var contentLoadedClass = 'content-loaded';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  let enableParallax = !(Utility.isMobile() || Utility.isIE() || Utility.isTablet());
  const heroSlidesSelector = '.js-hero-slides';
  const heroCarouselSelector = '.js-hero-carousel';
  const heroMediaSelector = '.hero-media';
  const playIconSelector = '.acr-icon.play-icon';
  const heroCtaSelector = '.hero-cta';
  const heroModalSelector = '.hero-modal';
  const slidesMediaSelector = '.hero-slide .hero-media';
  const swiperSlideActiveSelector = '.swiper-slide-active';
  const swiperSlideSelector = '.hero-slide';
  const anchorSelector = '[href]';
  let slidesMedia;
  let observer;
  let isParallaxRunning = false;

  function playVideo(video) {
    var findVideo;

    pauseVideo();

    findVideo = video.querySelector('video');

    if (findVideo && canPlayVideo) {
      findVideo.play();
    }
  }

  function resetVideo(video) {
    var findVideo;

    findVideo = video.querySelector('video');

    if (findVideo && canPlayVideo) {
      findVideo.currentTime = 0;
    }
  }

  document.addEventListener('keydown', function (e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    heroSwiper.autoplay.stop();
  });

  function pauseVideo() {
    hero.find('video').each(function () {
      if (canPlayVideo) {
        this.pause();
      }
    });
  }

  function checkIOS() {
    if (document.querySelector('html').classList.contains('appleios')) {
      canPlayVideo = false;
    }
  }

  function createMobileCTAs() {
    var cloneModal = '';
    var modal = '';
    var iconMarkup;

    hero.querySelectorAll('.hero-slide').forEach(function () {
      if (playSvg) {
        Utility.removeClassFromSvg(playSvg, 'hide');
        iconMarkup = playSvg.outerHTML;
        Utility.addClassToSvg(playSvg, 'hide');
      }
      modal = document.querySelector(heroModalSelector);

      if (modal) {
        cloneModal = modal.cloneNode(true);
        cloneModal.textContent = '';
        cloneModal.className = 'hero-modal';
        cloneModal.innerHTML = iconMarkup;
        media.insertBefore(cloneModal, media.childNodes[0]);
      }
    });
  }

  function setOnResize() {
    window.addEventListener('resize', function () {
      clearTimeout(triggerPos);
      triggerPos = setTimeout(resize, 100);
    });
  }

  function resize() {
    var width = window.innerWidth;
    var heroCta = heroSlider.querySelectorAll(heroCtaSelector);

    resizeMedia(width);

    enableParallax = !(Utility.isMobile() || Utility.isIE() || Utility.isTablet());
    if (enableParallax) {
      if (!isParallaxRunning) {
        initParallax();
      }
    } else {
      stopParallax();
    }
    if (width < Constants.breakpoints.sm) {
      if (breakpoint !== 'xs') {
        heroCta.forEach(function (element) { element.classList.add('acr-cta-r-w-b'); });
        hero.style.height = 'auto';
        breakpoint = 'xs';
      }
    } else if (breakpoint !== 'sm') {
      heroCta.forEach(function (element) { element.classList.remove('acr-cta-r-w-b'); });
      clearTimeout(triggerPos);
      breakpoint = 'sm';
    }
  }
  function stopParallax() {
    slidesMedia.forEach(function (element) { element.style.top = '0px'; });
    window.removeEventListener('scroll', doParallaxEffect);
    isParallaxRunning = false;
  }

  function onModal() {
    var findVideo;
    var acrModal = document.querySelector('.acr-modal');

    acrModal.addEventListener('show.bs.modal', function () {
      findVideo = this.querySelector('video');

      if (findVideo && canPlayVideo) {
        findVideo.play();
      }

      heroSwiper.autoplay.stop();
      clearTimeout(changeSlide);
    });

    acrModal.addEventListener('hidden.bs.modal', function () {
      findVideo = this.querySelector('video');

      if (findVideo && canPlayVideo) {
        findVideo.pause();
      }
    });
  }

  function resizeMedia(width) {
    var heightMedia = 0;
    var innerWidth = 0;

    if (hasScroll()) {
      innerWidth = width - 15;
    }

    if (width > 2000) {
      innerWidth = 2000;
    } else {
      innerWidth = width;
    }

    if (width >= Constants.breakpoints.sm
        && width < Constants.breakpoints.lg) {
      heightMedia = innerWidth / (ratioWidthSM / ratioHeightSM);
    } else {
      heightMedia = innerWidth / (ratioWidth / ratioHeight);
    }
    slidesMedia.forEach(function (element) { element.style.height = `${heightMedia}px`; });
  }

  function hasScroll() {
    var html = document.querySelector('html');

    return (html.scrollHeight > html.clientHeight);
  }

  function initHeroSwiper() {
    heroSwiper = new Swiper(heroSlider, {
      speed: 400,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft,
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        bulletClass: 'hero-carousel__bullet',
        renderBullet: function (index, className) {
          return `<span class="${className} js-tracking-tab" >${index + 1}</span>`;
        },
        bulletActiveClass: 'hero-carousel__bullet-active',
      },
      on: {
        init: function () {
          const swiperActive = document.querySelector(swiperSlideActiveSelector);
          setTheme(swiperActive.classList.contains('light-theme') ? 'light-theme' : 'dark-theme');
          const anchorsToEnable = swiperActive.querySelectorAll(anchorSelector);
          anchorsToEnable.forEach(function (element) { element.setAttribute('tabindex', '0'); });
        },
      },
    });

    heroSwiper.on('slideChangeTransitionEnd', function () {
      const swiperActive = document.querySelector(swiperSlideActiveSelector);
      const swiperSlide = document.querySelectorAll(swiperSlideSelector);
      let currentTheme = swiperActive.classList.contains('light-theme') ? 'light-theme' : 'dark-theme';
      if (!heroCarousel.classList.contains(currentTheme)) { setTheme(currentTheme); }
      swiperSlide.forEach(function (element) {
        const anchors = element.querySelectorAll(anchorSelector);
        if (element.classList.contains('swiper-slide-active')) {
          anchors.forEach(function (element) { element.setAttribute('tabindex', '0'); });
        } else {
          anchors.forEach(function (element) { element.setAttribute('tabindex', '-1'); });
        }
      });
    });

    // stoping autoplay waiting for onload event
    heroSwiper.autoplay.stop();
    slidesMedia = heroSlider.querySelectorAll(slidesMediaSelector);
  }

  function setTheme(theme) {
    let classToRemove = theme === 'light-theme' 
      ? 'dark-theme' : 'light-theme'; 
    heroCarousel.classList.add(theme);
    heroCarousel.classList.remove(classToRemove);
  }

  function displaySwiper() {
    heroSwiper.autoplay.start();
    heroSlider.classList.add(contentLoadedClass);
  }

  function doParallaxEffect() {
    const windowYOffset = window.pageYOffset;
    slidesMedia.forEach(function (element) { element.style.top = `${windowYOffset * 0.3}px`; });
  }

  function handler(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', doParallaxEffect);
      } else {
        window.removeEventListener('scroll', doParallaxEffect);
      }
    });
  }

  function initParallax(element) {
    isParallaxRunning = true;
    observer = new IntersectionObserver(handler);
    observer.observe(heroSlider);
  }

  function initSelectors(element) {
    heroSlider = element;
    hero = heroSlider.querySelector(heroSlidesSelector);
    swiperPagination = heroSlider.querySelector(swiperPaginationSelector);
    media = heroSlider.querySelector(heroMediaSelector);
    playSvg = heroSlider.querySelector(playIconSelector);
    arrowLeft = heroSlider.querySelector(arrowLeftSelector);
    arrowRight = heroSlider.querySelector(arrowRightSelector);
    slidesMedia = heroSlider.querySelectorAll(slidesMediaSelector);
    heroCarousel = document.querySelector(heroCarouselSelector);
  }

  function init(element) {
    initSelectors(element);
    checkIOS();
    resize();
    createMobileCTAs();
    setOnResize();
    onModal();
    initHeroSwiper();
    // Hero parallax animations
    if (enableParallax) {
      initParallax();
    }
    Utility.initDeferLoading(displaySwiper);
  }

  // Expose the following variables and functions
  return {
    init: init,
  };
};
